import { css, cx } from '@linaria/atomic';
import type { TableInstance } from 'react-table';
import { IconButton } from '../../';
import { useModalControl } from '../../';
import { FilterAltIcon } from '../../../icon';
import { TableFilters } from '../column-filters';
import { TableCommonStyles } from '../common-styles';
import { TableData } from '../table-data-type';
import type { ManualFilters } from '../table-types';

const filterContainerPositionStyle = css`
  position: relative;
`;

const filterAfterOpacityVisibleStyle = css`
  &::after {
    opacity: 1;
  }
`;

const filterAfterOpacityHiddenStyle = css`
  &::after {
    opacity: 0;
  }
`;

type FilterContainerProps<T extends TableData> = {
  tableInstance: TableInstance<T>;
  manualFiltersRender?: ManualFilters<T>;
};

export const FilterContainer = <T extends TableData>({
  tableInstance,
  manualFiltersRender,
}: FilterContainerProps<T>) => {
  const { modalProps, triggerProps } = useModalControl();
  const notificationBadgeStyles = TableCommonStyles.filterNotificationBadgeStyles;
  const { showEnabledFiltersBadge, setShowEnabledFiltersBadge, tableTrackingIds } = tableInstance;

  const isBadgeVisible = !!manualFiltersRender ? showEnabledFiltersBadge : !!tableInstance.state.filters.length;

  return (
    <>
      <div className={filterContainerPositionStyle}>
        <IconButton
          disabled={tableInstance.isLoading}
          label={'Filter'}
          color='light'
          data-test-id={tableTrackingIds.tableFilters}
          trackingId={tableTrackingIds.tableFilters}
          {...triggerProps}
          className={cx(
            notificationBadgeStyles,
            isBadgeVisible ? filterAfterOpacityVisibleStyle : filterAfterOpacityHiddenStyle
          )}
        >
          <FilterAltIcon />
        </IconButton>
      </div>
      {!!manualFiltersRender ? (
        manualFiltersRender(modalProps, setShowEnabledFiltersBadge, tableInstance)
      ) : (
        <TableFilters tableInstance={tableInstance} {...modalProps} />
      )}
    </>
  );
};
